import { ThumbsUpDoubleFilled } from "@carbon/icons-react";
import React from "react";
import { useTranslation } from "react-i18next";

export const AllDocumentsApproved = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-[206px] gap-[24px] flex flex-col items-center justify-center bg-white rounded shadow">
      <ThumbsUpDoubleFilled size={24} className="text-green-600" />
      <div className="flex flex-col items-center justify-center max-w-[412px]">
        <p className="text-[16px] leading-[20.16px]">{t("Nice Work!")}</p>
        <p className="text-[16px] leading-[20.16px] text-center text-gray-375 font-light">
          {t(
            "All your documents are approved, and you're now eligible for future exam enrollments.",
          )}
        </p>
      </div>
    </div>
  );
};
